var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1486_7771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1486_7771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10C9.08398 10 8.29926 9.67362 7.64648 9.02084C6.99371 8.36807 6.66732 7.58334 6.66732 6.66668C6.66732 5.75001 6.99371 4.96529 7.64648 4.31251C8.29926 3.65973 9.08398 3.33334 10.0007 3.33334C10.9173 3.33334 11.702 3.65973 12.3548 4.31251C13.0076 4.96529 13.334 5.75001 13.334 6.66668C13.334 7.58334 13.0076 8.36807 12.3548 9.02084C11.702 9.67362 10.9173 10 10.0007 10ZM3.33398 16.6667V14.3333C3.33398 13.8611 3.45551 13.4271 3.69857 13.0313C3.94162 12.6354 4.26454 12.3333 4.66732 12.125C5.52843 11.6945 6.40343 11.3715 7.29232 11.1563C8.18121 10.941 9.08398 10.8333 10.0007 10.8333C10.9173 10.8333 11.8201 10.941 12.709 11.1563C13.5979 11.3715 14.4729 11.6945 15.334 12.125C15.7368 12.3333 16.0597 12.6354 16.3027 13.0313C16.5458 13.4271 16.6673 13.8611 16.6673 14.3333V16.6667H3.33398ZM5.00065 15H15.0007V14.3333C15.0007 14.1806 14.9625 14.0417 14.8861 13.9167C14.8097 13.7917 14.709 13.6945 14.584 13.625C13.834 13.25 13.077 12.9688 12.3132 12.7813C11.5493 12.5938 10.7784 12.5 10.0007 12.5C9.22287 12.5 8.45204 12.5938 7.68815 12.7813C6.92426 12.9688 6.16732 13.25 5.41732 13.625C5.29232 13.6945 5.19162 13.7917 5.11523 13.9167C5.03885 14.0417 5.00065 14.1806 5.00065 14.3333V15ZM10.0007 8.33334C10.459 8.33334 10.8513 8.17015 11.1777 7.84376C11.5041 7.51737 11.6673 7.12501 11.6673 6.66668C11.6673 6.20834 11.5041 5.81598 11.1777 5.48959C10.8513 5.1632 10.459 5.00001 10.0007 5.00001C9.54232 5.00001 9.14996 5.1632 8.82357 5.48959C8.49718 5.81598 8.33398 6.20834 8.33398 6.66668C8.33398 7.12501 8.49718 7.51737 8.82357 7.84376C9.14996 8.17015 9.54232 8.33334 10.0007 8.33334Z",
    fill: "#1C1B1F",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2b0490c2e01f20cf019c03a03311cb00.svg";
export { ForwardRef as ReactComponent };